import { createContext, useContext } from "react";

export const LocationContext = createContext({
  coords: null,
  address: null,
  setCoords: () => {},
  setAddress: () => {},
});

export const useLocationContext = () => useContext(LocationContext);
